import React from 'react';
import { FaBuilding, FaUser } from 'react-icons/fa';
import { useAuth } from '../../contexts/authContext';
import { useSteps } from '../../contexts/stepContext';
import { useAppTranslation } from '../../hooks/useAppTranslation';
import { PersonType } from '../../services/services';
import { Title } from '../../styles/global';
import { Content } from '../BodyStep/styles';
import { FlowCard, FlowGrid, IconChip, UnavailableNote } from './styles';

/**
 * Escolha inicial do balcão: consulta de Pessoa Física ou de Pessoa Jurídica.
 *
 * Os dois cards aparecem sempre. O de um tipo que a empresa não contratou fica
 * desabilitado, com o aviso de que a opção existe para contratação — esconder
 * o card esconderia também que o produto existe.
 */
const FlowChooser: React.FC = () => {
  const { startFlow } = useSteps();
  const { hasPfServices, hasPjServices } = useAuth();
  const { translationPage } = useAppTranslation();
  const { tp } = translationPage(tr => tr.components.flowChooser);

  const options: Array<{
    type: PersonType;
    enabled: boolean;
    title: string;
    icon: React.ReactNode;
  }> = [
    {
      type: 'PF',
      enabled: hasPfServices,
      title: tp('pfTitle'),
      icon: <FaUser size={20} />,
    },
    {
      type: 'PJ',
      enabled: hasPjServices,
      title: tp('pjTitle'),
      icon: <FaBuilding size={20} />,
    },
  ];

  return (
    <Content>
      <Title>{tp('title')}</Title>
      <FlowGrid>
        {options.map(option => (
          <FlowCard
            key={option.type}
            type="button"
            disabled={!option.enabled}
            onClick={() => startFlow(option.type)}
          >
            <IconChip>{option.icon}</IconChip>
            <strong>{option.title}</strong>
            <span>{tp('description')}</span>
            {!option.enabled && (
              <UnavailableNote>{tp('unavailable')}</UnavailableNote>
            )}
          </FlowCard>
        ))}
      </FlowGrid>
    </Content>
  );
};

export default FlowChooser;
